import { Component, Input, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';

import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DialogModule } from 'primeng/dialog';
import { ProgressBarModule } from 'primeng/progressbar';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { InputNumberModule } from 'primeng/inputnumber';


import { AjaxService } from '../../../services/ajax.service';
import { TranslateService } from '../../../services/translate.service';
import { ViewScopeService } from '../../../services/view-scope.service';

import { MERGE_FILES } from '../../../services/account-api.constants';



@Component({
	selector: 'app-merge-dialog',
	standalone: true,
	imports: [
		CommonModule,
		DialogModule,
		ProgressBarModule,
		TableModule,
		ButtonModule,
		FormsModule,
		InputNumberModule
	],
	templateUrl: './merge-dialog.component.html',
	styleUrls: ['./merge-dialog.component.scss'],
	providers: [DatePipe]
})

export class MergenDialogComponent {
	@Input() visible: boolean = false;
	@Output() visibleChange = new EventEmitter<boolean>();

	@Input() mergeList: any[] = [];
	@Output() remove = new EventEmitter<number>();
	@Output() merge = new EventEmitter<void>();
	@Output() dialogClosed = new EventEmitter<{ merged: boolean }>();

	// Track loading and MergeRecID for each group
	groupLoading: { [groupKey: string]: boolean } = {};
	groupResult: { [groupKey: string]: string | null } = {};
	merging: boolean = false;
	private mergePerformed: boolean = false;

	constructor(
		private ajaxService: AjaxService,
		private viewScopeService: ViewScopeService,
		public translateServ: TranslateService,
		private cdr: ChangeDetectorRef
	) { }

	close(): void 
	{
		// Remove files that got a MergeRecID (successfully merged)
		const mergedGroups = Object.keys(this.groupResult).filter(
			groupKey => this.groupResult[groupKey] && this.groupResult[groupKey] !== 'Error' && this.groupResult[groupKey] !== 'No'
		).map(Number);

		if (this.mergeList && mergedGroups.length > 0) this.mergeList = this.mergeList.filter(file => !mergedGroups.includes(file.Group || 1));

		this.visible = false;
		this.visibleChange.emit(false);
		this.dialogClosed.emit({ merged: this.mergePerformed });

		// Reset status only when dialog is closed
		this.groupLoading = {};
		this.groupResult = {};
		this.merging = false;
		this.mergePerformed = false;
	}

	// Ensure every file has a Group property (default 1)
	ngOnChanges() 
	{
		if (this.mergeList) 
		{
			this.mergeList.forEach(file => {
				if (file.Group == null) file.Group = 1;
			});
		}
	}

	onGroupChange(file: any, rowIndex: number) 
	{
		// Optionally validate or handle group changes here
		if (!file.Group || file.Group < 1) file.Group = 1;
	}

	// Call this to merge each group separately
	mergeFilesByGroup() {
		this.merging = true;
		this.mergePerformed = true;
		const customerRecId = this.viewScopeService.getCurrentCustomer();
		const userRecId = this.viewScopeService.getCurrentOpertaingUserId();
		// Group files by Group property
		const groups: { [key: string]: any[] } = {};
		(this.mergeList || []).forEach(file => {
			const group = file.Group || 1;
			const groupKey = String(group);
			if (!groups[groupKey]) groups[groupKey] = [];
			groups[groupKey].push({ FileRecID: file.FileRecID, PageNum: 1 });
		});

		const groupKeys = Object.keys(groups).filter(groupNum => groups[groupNum].length > 1);
		if (groupKeys.length === 0) {
			this.merging = false;
			this.mergePerformed = false;
			return;
		}

		let completed = 0;
		groupKeys.forEach((groupNum: string) => {
			const files = groups[groupNum];
			this.groupLoading[groupNum] = true;
			this.groupResult[groupNum] = null;
			const payload = {
				CustomerRecID: customerRecId,
				UserRecID: userRecId,
				Files: files
			};
			this.ajaxService.addObjectData(
				this.ajaxService.getBaseOfApi() + MERGE_FILES,
				JSON.stringify(payload)
			).subscribe({
				next: (res) => {
					this.groupLoading[groupNum] = false;
					// Use 'as any' to access MergeRecID
					const mergeId = (res as any)[0]?.MergeRecID;
					this.groupResult[groupNum] = mergeId ? String(mergeId) : 'No';
					completed++;
					this.cdr.detectChanges();
					if (completed === groupKeys.length) {
						this.merging = false;
					}
				},
				error: (err) => {
					this.groupLoading[groupNum] = false;
					this.groupResult[groupNum] = 'Error';
					completed++;
					this.cdr.detectChanges();
					if (completed === groupKeys.length) {
						this.merging = false;
					}
				}
			});
		});
	}
}